var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import InputField from "@frameworks/web/components/generic/inputField";
import "@frameworks/salesjourney/stylesheets/components/Features/AOPLeads/AOPLeads.scss";
import leadDI from "@frameworks/salesjourney/components/Features/LeadDashboard/di/serviceLocator";
import AOPLeadTable from "./AOPLeadTable";
var AOPLeads = function () {
    var _a = __read(useState(false), 2), loader = _a[0], setLoader = _a[1];
    var _b = __read(useState(null), 2), AOPLeadData = _b[0], setAOPLeadData = _b[1];
    var _c = __read(React.useState(""), 2), searchText = _c[0], setSearchText = _c[1];
    var getDIYSearchAOPLeadDetails = function (currentPage) {
        if (currentPage === void 0) { currentPage = 1; }
        setLoader(true);
        var payload = {
            SearchText: searchText,
            Page: currentPage,
            pageSize: 50,
        };
        leadDI.leads
            .getDIYSearchAOPLeadDetails(payload)
            .then(function (resp) {
            setAOPLeadData(resp);
            setLoader(false);
        })
            .catch(function (error) {
            console.log("error", error);
            setAOPLeadData(null);
            setLoader(false);
        });
    };
    return (React.createElement("div", { className: "aop-leads-main-container" },
        React.createElement("div", { className: "aop-title DMSansMedium_20_500 txt_blackOne1 mb-2" }, "Account opening Leads"),
        React.createElement("div", { className: "aop-title DMSanM_14_500 txt_blackOne1 col mb-4" }, "Enter details below to find matching leads"),
        React.createElement(InputField, { placeholderClassName: "", prefix: React.createElement("i", { onClick: function () {
                    if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) > 2) {
                        getDIYSearchAOPLeadDetails();
                    }
                    else if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) == 0) {
                        setAOPLeadData(null);
                    }
                }, className: "hand_cursor edel-icon-search1" }), className: "filter-search  DMSanN_16_400 txt_secondary-gray input-group input-group-with-search pe-3  ".concat("new-design-search"), placeholder: "Enter Client Name / Lead ID / Mobile", onBlur: function () { }, defaultValue: searchText, onChangeEvent: function (e) {
                setSearchText(e.target.value);
            }, onKeyDown: function (e) {
                if (e.code === "Enter") {
                    if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) > 2) {
                        getDIYSearchAOPLeadDetails();
                    }
                    else if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) == 0) {
                        setAOPLeadData(null);
                    }
                }
                if (e.code === "Backspace") {
                    setSearchText("");
                }
            }, maxLength: 100 }),
        React.createElement(AOPLeadTable, { setCurrentPage: function (currentPage) {
                getDIYSearchAOPLeadDetails(currentPage);
            }, loader: loader, AOPLeadData: AOPLeadData, setAOPLeadData: setAOPLeadData })));
};
export default AOPLeads;
